export const environment = {
   base_url: process.env.REACT_APP_DEV_URL,
   web_socket_url: process.env.REACT_APP_SOCKET_DEV_URL,
   image_base_url: process.env.REACT_APP_IMAGE_DEV_URL
}
